// /signin — Figma frame 01 sign-in (33:308). Owner: screens-auth-a, US-080.
// Pre-login: deliberately no AppShell.

import { createRoute, useNavigate } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { SigninScreen } from "../screens/signin/SigninScreen";

export const signinRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/signin",
  component: SigninRoute,
});

function SigninRoute() {
  const navigate = useNavigate();
  return (
    <SigninScreen
      onSent={(email) =>
        navigate({ to: "/auth/link-sent", search: { email } })
      }
    />
  );
}
